<template>
    <div class="about-us-banner" :style="{ 'background-image': 'url(/images/about/deltafactory3.jpg)' }">
        <div class="bg-section">
            <div class="bg-text">About Us</div>
        </div>
    </div>
    <div
        class="page-template-default page page-id-958 theme-delta woocommerce-js wrapper-full-width global-cart-design-2 global-search-disable mobile-nav-from-left form-style-square form-border-width-2 menu-style-default dropdowns-color-dark no-sticky-footer woodmart-light catalog-mode-off categories-accordion-on global-wishlist-enable woodmart-top-bar-off woodmart-top-bar-mobile-off woodmart-ajax-shop-on woodmart-ajax-search-on logo-responsive-on offcanvas-sidebar-mobile offcanvas-sidebar-tablet enable-sticky-header woodmart-header-base sticky-header-clone btns-default-flat btns-default-dark btns-default-hover-dark btns-shop-3d btns-shop-light btns-shop-hover-light btns-accent-flat btns-accent-light btns-accent-hover-light wpb-js-composer js-comp-ver-5.4.5 vc_responsive sticky-header-prepared document-ready">
        <div class="website-wrapper">
            <div class="clear"></div>

            <div class="main-page-wrapper">
                <div class="container">
                    <div class="row content-layout-wrapper">
                        <div class="site-content col-sm-12" role="main" style="margin-top: 40px !important">
                            <article id="post-958" class="post-958 page type-page status-publish hentry">
                                <div class="entry-content">
                                    <div class="vc_row-full-width vc_clearfix"></div>

                                    <div
                                        class="vc_row wpb_row vc_row-fluid vc_custom_1504016749019 vc_row-o-content-middle vc_row-flex">
                                        <div class="wpb_column vc_column_container vc_col-sm-12 vc_col-md-6">
                                            <div class="vc_column-inner vc_custom_1503987927476">
                                                <div class="wpb_wrapper">
                                                    <div class="vc_row wpb_row vc_inner vc_row-fluid">
                                                        <div
                                                            class="wpb_column vc_column_container vc_col-sm-6 vc_col-xs-12">
                                                            <div class="vc_column-inner vc_custom_1502961612862">
                                                                <div class="wpb_wrapper">
                                                                    <div class="vc_empty_space hidden-sm hidden-xs"
                                                                        style="
                                                                            height: 4vh;
                                                                        ">
                                                                        <span class="vc_empty_space_inner"></span>
                                                                    </div>

                                                                    <div
                                                                        class="wpb_single_image wpb_content_element vc_align_center vc_custom_1522902979938">
                                                                        <figure class="wpb_wrapper vc_figure">
                                                                            <div
                                                                                class="vc_single_image-wrapper vc_box_border_grey">
                                                                                <img class="vc_single_image-img"
                                                                                    src="/images/about/aboutus3.jpg"
                                                                                    alt="aboutus3" title="aboutus3"
                                                                                    width="400" height="600" />
                                                                            </div>
                                                                        </figure>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <!-- <div
                                                            class="wpb_column vc_column_container vc_col-sm-6 vc_col-xs-12">
                                                            <div class="vc_column-inner vc_custom_1502961619083">
                                                                <div class="wpb_wrapper">
                                                                    <div
                                                                        class="wpb_single_image wpb_content_element vc_align_center vc_custom_1515576304324">
                                                                        <figure class="wpb_wrapper vc_figure">
                                                                            <div
                                                                                class="vc_single_image-wrapper vc_box_border_grey">
                                                                                <img class="vc_single_image-img"
                                                                                    src="/images/about/deltacorporate.jpg"
                                                                                    alt="deltacorporate"
                                                                                    title="deltacorporate" width="400"
                                                                                    height="600" />
                                                                            </div>
                                                                        </figure>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div> -->
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="wpb_column vc_column_container vc_col-sm-12 vc_col-md-6">
                                            <div class="vc_column-inner vc_custom_1504016632988">
                                                <div class="wpb_wrapper">
                                                    <div id="woodmart-text-block-id-642288370a192"
                                                        class="woodmart-text-block-wrapper color-scheme-dark woodmart-title-size-custom woodmart-title-width-100 text-center vc_custom_1515565783174">
                                                        <div
                                                            class="woodmart-title-container woodmart-text-block font-primary woodmart-font-weight-400">
                                                            <strong>About Us<br />
                                                            </strong>
                                                        </div>
                                                    </div>

                                                    <div id="woodmart-text-block-id-642288370a1b9"
                                                        class="woodmart-text-block-wrapper color-scheme- woodmart-title-size-custom woodmart-title-width-80 text-center vc_custom_1515565894732">
                                                        <div
                                                            class="woodmart-title-container woodmart-text-block font-text woodmart-font-weight-">
                                                            <p></p>
                                                            <p style="
                                                                    text-align: justify;
                                                                ">
                                                                Our brand has evolved, with the inclusion of our Design
                                                                Studio and a stronger emphasis on workmanship and
                                                                high-quality materials. Today, we prioritize three
                                                                areas: developing our designs, providing excellent
                                                                customer service, and creating long-lasting products.
                                                                From our design floor to our stores, our ultimate goal
                                                                is the same: to help our customers live easier, more
                                                                beautiful, and more pleasant lives at home.
                                                            </p>
                                                            <p></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div data-vc-full-width="true" data-vc-full-width-init="true"
                                        data-vc-stretch-content="true"
                                        class="d-none d-lg-block vc_row wpb_row vc_row-fluid vc_custom_1502962403521 vc_row-no-padding vc_row-o-content-top vc_row-flex"
                                        style="
                                            position: relative;
                                            left: -349px;
                                            box-sizing: border-box;
                                            width: 1920px;
                                        ">
                                        <div
                                            class="wpb_column vc_column_container vc_col-sm-2 vc_hidden-sm vc_hidden-xs">
                                            <div class="vc_column-inner vc_custom_1502961799206">
                                                <div class="wpb_wrapper">
                                                    <div class="promo-banner-wrapper" id="banner-id-642288370a4d7">
                                                        <div class="promo-banner cursor-pointer banner-vr-align-top banner-hr-align-left banner-mask banner-hover-zoom color-scheme-light banner-btn-size-small banner-btn-style-bordered banner-increased-padding with-btn banner-btn-position-static"
                                                            onclick="process.client ? window.location.href='#' : '#'">
                                                            <div class="main-wrapp-img">
                                                                <div class="banner-image">
                                                                    <img class="promo-banner-image image-1"
                                                                        src="/images/about/deltaimgwood.jpg"
                                                                        alt="deltaimgwood" width="383" height="957" />
                                                                </div>
                                                            </div>

                                                            <div class="wrapper-content-banner">
                                                                <div
                                                                    class="content-banner text-left content-width-100 content-spacing-default">
                                                                    <div
                                                                        class="banner-title-wrap banner-title-extra-large">
                                                                        <span
                                                                            class="banner-subtitle subtitle-color-default subtitle-style-default">AKHTAR</span>
                                                                        <h4
                                                                            class="banner-title woodmart-font-weight-600">
                                                                            Many
                                                                            of
                                                                            our<br />
                                                                            products
                                                                            are<br />
                                                                            made
                                                                            with<br />
                                                                            wood<br />
                                                                        </h4>
                                                                    </div>
                                                                    <div class="banner-btn-wrapper">
                                                                        <div class="woodmart-button-wrapper text-left">
                                                                            <a href="#" title=""
                                                                                class="btn btn-color-white btn-style-bordered btn-size-small">READ
                                                                                MORE</a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="wpb_column vc_column_container vc_col-sm-12 vc_col-md-5">
                                            <div class="vc_column-inner vc_custom_1502961869165">
                                                <div class="wpb_wrapper">
                                                    <div
                                                        class="vc_row wpb_row vc_inner vc_row-fluid vc_row-o-equal-height vc_row-o-content-middle vc_row-flex">
                                                        <div class="wpb_column vc_column_container vc_col-sm-6">
                                                            <div class="vc_column-inner vc_custom_1504092645215">
                                                                <div class="wpb_wrapper">
                                                                    <div class="promo-banner-wrapper"
                                                                        id="banner-id-642288370ac53">
                                                                        <div class="promo-banner cursor-pointer banner-vr-align-middle banner-hr-align-left banner-mask banner-hover-zoom color-scheme-light banner-btn-size-default banner-btn-style-link banner-increased-padding"
                                                                            onclick="process.client ? window.location.href='#' : '#'">
                                                                            <div class="main-wrapp-img">
                                                                                <div class="banner-image">
                                                                                    <img src="/images/about/4.jpg"
                                                                                        class="promo-banner-image image-1 attachment-full"
                                                                                        alt="" width="727"
                                                                                        height="727" />
                                                                                </div>
                                                                            </div>

                                                                            <div class="wrapper-content-banner">
                                                                                <div
                                                                                    class="content-banner text-left content-width-100 content-spacing-default">
                                                                                    <div
                                                                                        class="banner-title-wrap banner-title-large">
                                                                                    </div>
                                                                                    <div
                                                                                        class="banner-inner content-size-default">
                                                                                        <p></p>
                                                                                        <h1></h1>
                                                                                        <p></p>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="wpb_column vc_column_container vc_col-sm-6 vc_col-has-fill">
                                                            <div class="vc_column-inner vc_custom_1504019441256">
                                                                <div class="wpb_wrapper">
                                                                    <div id="woodmart-title-id-642288370b1cb"
                                                                        class="title-wrapper woodmart-title-color-white woodmart-title-style-default woodmart-title-size-large woodmart-title-width-80 text-center vc_custom_1515652773973">
                                                                        <div class="liner-continer">
                                                                            <span class="left-line"></span>
                                                                            <h5
                                                                                class="woodmart-title-container title woodmart-font-weight-">
                                                                                New
                                                                                designs
                                                                            </h5>
                                                                            <span class="right-line"></span>
                                                                        </div>

                                                                        <div class="title-after_title">
                                                                            Discover
                                                                            a
                                                                            world
                                                                            of
                                                                            cool,
                                                                            contemporary
                                                                            pieces,
                                                                            new
                                                                            colors,
                                                                            new
                                                                            functionalities
                                                                            and
                                                                            exciting
                                                                            materials.
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="vc_row wpb_row vc_inner vc_row-fluid vc_row-o-equal-height vc_row-o-content-middle vc_row-flex row-reverse-mobile">
                                                        <div
                                                            class="wpb_column vc_column_container vc_col-sm-6 vc_col-has-fill">
                                                            <div class="vc_column-inner vc_custom_1504019342061">
                                                                <div class="wpb_wrapper">
                                                                    <div id="woodmart-title-id-642288370b3b9"
                                                                        class="title-wrapper woodmart-title-color-white woodmart-title-style-default woodmart-title-size-large woodmart-title-width-80 text-center vc_custom_1515566882223">
                                                                        <div class="liner-continer">
                                                                            <span class="left-line"></span>
                                                                            <h4
                                                                                class="woodmart-title-container title woodmart-font-weight-">
                                                                                Development
                                                                            </h4>
                                                                            <span class="right-line"></span>
                                                                        </div>

                                                                        <div class="title-after_title">
                                                                            We
                                                                            have
                                                                            a
                                                                            steadfast
                                                                            commitment
                                                                            to
                                                                            quality
                                                                            and
                                                                            take
                                                                            great
                                                                            pride
                                                                            in
                                                                            our
                                                                            timeless
                                                                            designs,
                                                                            premium
                                                                            materials
                                                                            and
                                                                            expert
                                                                            craftsmanship.
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="wpb_column vc_column_container vc_col-sm-6">
                                                            <div class="vc_column-inner">
                                                                <div class="wpb_wrapper">
                                                                    <div class="promo-banner-wrapper"
                                                                        id="banner-id-642288370b4ac">
                                                                        <div class="promo-banner cursor-pointer banner-vr-align-middle banner-hr-align-left banner-mask banner-hover-zoom color-scheme-light banner-btn-size-default banner-btn-style-link banner-increased-padding"
                                                                            onclick="process.client ? window.location.href='#' : '#'">
                                                                            <div class="main-wrapp-img">
                                                                                <div class="banner-image">
                                                                                    <img src="/images/about/6.jpg"
                                                                                        class="promo-banner-image image-1 attachment-full"
                                                                                        alt="" width="727"
                                                                                        height="727" />
                                                                                </div>
                                                                            </div>

                                                                            <div class="wrapper-content-banner">
                                                                                <div
                                                                                    class="content-banner text-left content-width-100 content-spacing-default">
                                                                                    <div
                                                                                        class="banner-title-wrap banner-title-large">
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="wpb_column vc_column_container vc_col-sm-12 vc_col-md-5">
                                            <div class="vc_column-inner vc_custom_1502961875388">
                                                <div class="wpb_wrapper">
                                                    <div class="promo-banner-wrapper" id="banner-id-642288370b9a1">
                                                        <div class="promo-banner cursor-pointer banner-vr-align-middle banner-hr-align-center banner-mask banner-hover-zoom color-scheme-light banner-btn-size-default banner-btn-style-bordered banner-increased-padding with-btn banner-btn-position-static"
                                                            onclick="process.client ? window.location.href='#' : '#'">
                                                            <div class="main-wrapp-img">
                                                                <div class="banner-image">
                                                                    <img src="/images/about/deltafurnitureimg2.jpg"
                                                                        class="promo-banner-image image-1 attachment-full"
                                                                        alt="" width="1280" height="1280" />
                                                                </div>
                                                            </div>

                                                            <div class="wrapper-content-banner">
                                                                <div
                                                                    class="content-banner text-center content-width-100 content-spacing-default">
                                                                    <div class="banner-title-wrap banner-title-default">
                                                                        <span
                                                                            class="banner-subtitle subtitle-color-default subtitle-style-default"><strong>AKHTAR</strong></span>
                                                                        <h4
                                                                            class="banner-title woodmart-font-weight-600">
                                                                            More
                                                                            than
                                                                            a
                                                                            furniture
                                                                            store
                                                                        </h4>
                                                                    </div>
                                                                    <div class="banner-inner content-size-default">
                                                                        <p></p>
                                                                        <p style="
                                                                                text-align: center;
                                                                            ">
                                                                            We
                                                                            are
                                                                            not
                                                                            just
                                                                            another
                                                                            furniture
                                                                            store.
                                                                            We
                                                                            have
                                                                            worked
                                                                            with
                                                                            interior
                                                                            design,
                                                                            and
                                                                            we
                                                                            have
                                                                            a
                                                                            strong
                                                                            set
                                                                            of
                                                                            beliefs
                                                                            that
                                                                            run
                                                                            through
                                                                            everything
                                                                            we
                                                                            do.
                                                                        </p>
                                                                        <p></p>
                                                                    </div>
                                                                    <div class="banner-btn-wrapper">
                                                                        <div
                                                                            class="woodmart-button-wrapper text-center">
                                                                            <a href="#" title=""
                                                                                class="btn btn-color-white btn-style-bordered btn-size-default">READ
                                                                                MORE</a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="vc_row-full-width vc_clearfix"></div>
                                    <div
                                        class="vc_row wpb_row vc_row-fluid vc_custom_1504079499615 vc_row-o-content-middle vc_row-flex">
                                        <div class="wpb_column vc_column_container vc_col-sm-6">
                                            <div class="vc_column-inner vc_custom_1504079673177">
                                                <div class="wpb_wrapper">
                                                    <div
                                                        class="vc_row wpb_row vc_inner vc_row-fluid vc_row-o-content-middle vc_row-flex">
                                                        <div class="wpb_column vc_column_container vc_col-sm-6">
                                                            <div class="vc_column-inner vc_custom_1502454527869">
                                                                <div class="wpb_wrapper">
                                                                    <div
                                                                        class="wpb_single_image wpb_content_element vc_align_center vc_custom_1515577302017">
                                                                        <figure class="wpb_wrapper vc_figure">
                                                                            <div
                                                                                class="vc_single_image-wrapper vc_box_border_grey">
                                                                                <img class="vc_single_image-img"
                                                                                    src="/images/about/deltaqualityimg2.jpg"
                                                                                    alt="deltaqualityimg2"
                                                                                    title="deltaqualityimg2" width="400"
                                                                                    height="500" />
                                                                            </div>
                                                                        </figure>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="wpb_column vc_column_container vc_col-sm-6">
                                                            <div class="vc_column-inner vc_custom_1502454533190">
                                                                <div class="wpb_wrapper">
                                                                    <div
                                                                        class="wpb_single_image wpb_content_element vc_align_center vc_custom_1515576800565">
                                                                        <figure class="wpb_wrapper vc_figure">
                                                                            <div
                                                                                class="vc_single_image-wrapper vc_box_border_grey">
                                                                                <img class="vc_single_image-img"
                                                                                    src="/images/about/qualitycraftman.jpg"
                                                                                    alt="qualitycraftman"
                                                                                    title="qualitycraftman" width="400"
                                                                                    height="600" />
                                                                            </div>
                                                                        </figure>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="wpb_column vc_column_container vc_col-sm-6">
                                            <div class="vc_column-inner vc_custom_1504079485859">
                                                <div class="wpb_wrapper">
                                                    <div id="woodmart-text-block-id-642288370cc40"
                                                        class="woodmart-text-block-wrapper color-scheme-dark woodmart-title-size-custom woodmart-title-width-100 text-left vc_custom_1515566298837">
                                                        <div
                                                            class="woodmart-title-container woodmart-text-block font-primary woodmart-font-weight-400">
                                                            <strong>Our
                                                                Quality:</strong>
                                                        </div>
                                                    </div>

                                                    <div id="woodmart-text-block-id-642288370cc62"
                                                        class="woodmart-text-block-wrapper color-scheme- woodmart-title-size-custom woodmart-title-width-80 text-left vc_custom_1515566361672">
                                                        <div
                                                            class="woodmart-title-container woodmart-text-block font-text woodmart-font-weight-">
                                                            Quality is the first
                                                            thing which we
                                                            consider. To serve
                                                            you the best we
                                                            always maintain best
                                                            quality by
                                                            observing, studying
                                                            &amp; compromising.
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        class="vc_row wpb_row vc_row-fluid vc_custom_1504181248563 vc_row-o-content-middle vc_row-flex row-reverse-mobile">
                                        <div class="text-right wpb_column vc_column_container vc_col-sm-6">
                                            <div class="vc_column-inner vc_custom_1504079490508">
                                                <div class="wpb_wrapper">
                                                    <div id="woodmart-text-block-id-642288370ce86"
                                                        class="woodmart-text-block-wrapper color-scheme-dark woodmart-title-size-custom woodmart-title-width-100 text-right vc_custom_1515566392668">
                                                        <div
                                                            class="woodmart-title-container woodmart-text-block font-primary woodmart-font-weight-400">
                                                            <strong>Home
                                                                Furniture:</strong>
                                                        </div>
                                                    </div>

                                                    <div id="woodmart-text-block-id-642288370cea8"
                                                        class="woodmart-text-block-wrapper color-scheme- woodmart-title-size-custom woodmart-title-width-80 text-right vc_custom_1515566492129">
                                                        <div
                                                            class="woodmart-title-container woodmart-text-block font-text woodmart-font-weight-">
                                                            AKHTAR offers you all
                                                            kind of home
                                                            furniture including
                                                            living room, bed
                                                            room &amp; kitchen
                                                            furniture with
                                                            variations. We
                                                            promise you that our
                                                            home furniture will
                                                            be the perfect
                                                            reflection of your
                                                            personality
                                                            &amp;amp; comfort.
                                                            To make your home
                                                            your perfect
                                                            reflection, our
                                                            designers develop
                                                            every piece of
                                                            furniture and we
                                                            monitoring every
                                                            steps from designing
                                                            to manufacturing
                                                            even testing. We
                                                            maintain top most
                                                            quality in our
                                                            furniture. No
                                                            compromises even
                                                            consider. We
                                                            carefully select
                                                            durable materials,
                                                            like solid wood and
                                                            metals that won’t
                                                            deteriorate over
                                                            time. We always
                                                            consider comfort,
                                                            style and quality
                                                            during the product
                                                            development times.
                                                            We provide you the
                                                            best that you
                                                            deserve.
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="vc_row-reverse-mobile wpb_column vc_column_container vc_col-sm-6">
                                            <div class="vc_column-inner vc_custom_1504079666614">
                                                <div class="wpb_wrapper">
                                                    <div
                                                        class="vc_row wpb_row vc_inner vc_row-fluid vc_row-o-content-middle vc_row-flex">
                                                        <div class="wpb_column vc_column_container vc_col-sm-6">
                                                            <div class="vc_column-inner vc_custom_1502454533190">
                                                                <div class="wpb_wrapper">
                                                                    <div
                                                                        class="wpb_single_image wpb_content_element vc_align_center vc_custom_1515578409793">
                                                                        <figure class="wpb_wrapper vc_figure">
                                                                            <div
                                                                                class="vc_single_image-wrapper vc_box_border_grey">
                                                                                <img class="vc_single_image-img"
                                                                                    src="/images/about/furniturehomedelta-1.jpg"
                                                                                    alt="furniturehomedelta"
                                                                                    title="furniturehomedelta"
                                                                                    width="400" height="600" />
                                                                            </div>
                                                                        </figure>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="wpb_column vc_column_container vc_col-sm-6">
                                                            <div class="vc_column-inner vc_custom_1502454527869">
                                                                <div class="wpb_wrapper">
                                                                    <div
                                                                        class="wpb_single_image wpb_content_element vc_align_center vc_custom_1515577585510">
                                                                        <figure class="wpb_wrapper vc_figure">
                                                                            <div
                                                                                class="vc_single_image-wrapper vc_box_border_grey">
                                                                                <img class="vc_single_image-img"
                                                                                    src="/images/about/deltahome1.jpg"
                                                                                    alt="deltahome1" title="deltahome1"
                                                                                    width="400" height="500" />
                                                                            </div>
                                                                        </figure>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        class="vc_row wpb_row vc_row-fluid vc_custom_1504079499615 vc_row-o-content-middle vc_row-flex">
                                        <div class="wpb_column vc_column_container vc_col-sm-6">
                                            <div class="vc_column-inner vc_custom_1504079673177">
                                                <div class="wpb_wrapper">
                                                    <div
                                                        class="vc_row wpb_row vc_inner vc_row-fluid vc_row-o-content-middle vc_row-flex">
                                                        <div class="wpb_column vc_column_container vc_col-sm-6">
                                                            <div class="vc_column-inner vc_custom_1502454527869">
                                                                <div class="wpb_wrapper">
                                                                    <div
                                                                        class="wpb_single_image wpb_content_element vc_align_center vc_custom_1515578777936">
                                                                        <figure class="wpb_wrapper vc_figure">
                                                                            <div
                                                                                class="vc_single_image-wrapper vc_box_border_grey">
                                                                                <img class="vc_single_image-img"
                                                                                    src="/images/about/deltaoffice2.jpg"
                                                                                    alt="deltaoffice2"
                                                                                    title="deltaoffice2" width="400"
                                                                                    height="500" />
                                                                            </div>
                                                                        </figure>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="wpb_column vc_column_container vc_col-sm-6">
                                                            <div class="vc_column-inner vc_custom_1502454533190">
                                                                <div class="wpb_wrapper">
                                                                    <div
                                                                        class="wpb_single_image wpb_content_element vc_align_center vc_custom_1515578654032">
                                                                        <figure class="wpb_wrapper vc_figure">
                                                                            <div
                                                                                class="vc_single_image-wrapper vc_box_border_grey">
                                                                                <img class="vc_single_image-img"
                                                                                    src="/images/about/deltaofficefurniture.jpg"
                                                                                    alt="deltaofficefurniture"
                                                                                    title="deltaofficefurniture"
                                                                                    width="400" height="600" />
                                                                            </div>
                                                                        </figure>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="wpb_column vc_column_container vc_col-sm-6">
                                            <div class="vc_column-inner vc_custom_1504079485859">
                                                <div class="wpb_wrapper">
                                                    <div id="woodmart-text-block-id-642288370e6f1"
                                                        class="woodmart-text-block-wrapper color-scheme-dark woodmart-title-size-custom woodmart-title-width-100 text-left vc_custom_1515566567550">
                                                        <div
                                                            class="woodmart-title-container woodmart-text-block font-primary woodmart-font-weight-400">
                                                            <strong>Office
                                                                Furniture:</strong>
                                                        </div>
                                                    </div>

                                                    <div id="woodmart-text-block-id-642288370e711"
                                                        class="woodmart-text-block-wrapper color-scheme- woodmart-title-size-custom woodmart-title-width-90 text-left vc_custom_1515567560455">
                                                        <div
                                                            class="woodmart-title-container woodmart-text-block font-text woodmart-font-weight-">
                                                            Great workplace
                                                            inspires people to
                                                            perform well. AKHTAR
                                                            is manufacturing
                                                            office furniture to
                                                            help the
                                                            organizations to
                                                            create places that
                                                            they promise of
                                                            provide their
                                                            people. And we
                                                            promised to create
                                                            those places of an
                                                            organization that
                                                            inspire their people
                                                            to perform best. We
                                                            are manufacturing
                                                            our office furniture
                                                            to improve health
                                                            and comfort at work.
                                                            We design our
                                                            product by keeping
                                                            the idea of
                                                            different workplace
                                                            in our mind. We
                                                            observe every detail
                                                            in the production
                                                            process and choose
                                                            the best possible
                                                            materials. During
                                                            the manufacturing
                                                            process we consider
                                                            comfort &amp;
                                                            durability. To make
                                                            our product
                                                            comfortable we use
                                                            advanced technology
                                                            and sophisticated
                                                            machines.<br />
                                                            From our
                                                            manufacturing plant
                                                            to our store, every
                                                            stages like-
                                                            manufacturing,
                                                            finishing, packaging
                                                            &amp; organizing are
                                                            executed carefully.
                                                            We are always ready
                                                            to serve you with
                                                            our office
                                                            solutions. Being
                                                            user friendly and
                                                            sustainable, our
                                                            office furniture
                                                            makes your office a
                                                            perfect workplace.
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div data-vc-full-width="true" data-vc-full-width-init="true"
                                        data-vc-stretch-content="true"
                                        class="d-none d-lg-block vc_row wpb_row vc_row-fluid vc_row-no-padding vc_row-o-equal-height vc_row-o-content-middle vc_row-flex"
                                        style="
                                            position: relative;
                                            left: -349px;
                                            box-sizing: border-box;
                                            width: 1920px;
                                        ">
                                        <div
                                            class="wpb_column vc_column_container vc_col-sm-12 vc_col-md-6 vc_col-has-fill color-scheme-light">
                                            <div class="vc_column-inner vc_custom_1515663857276">
                                                <div class="wpb_wrapper">
                                                    <div id="woodmart-text-block-id-642288370e994"
                                                        class="woodmart-text-block-wrapper color-scheme-light woodmart-title-size-custom woodmart-title-width-100 text-center vc_custom_1515568232256">
                                                        <div
                                                            class="woodmart-title-container woodmart-text-block font-primary woodmart-font-weight-400">
                                                            OUR <strong>DESIGN</strong>
                                                        </div>
                                                    </div>

                                                    <div id="woodmart-text-block-id-642288370e9b2"
                                                        class="woodmart-text-block-wrapper color-scheme-light woodmart-title-size-custom woodmart-title-width-100 text-center">
                                                        <div
                                                            class="woodmart-title-container woodmart-text-block font-text woodmart-font-weight-">
                                                            Our products are
                                                            imagined and
                                                            designed by us. We
                                                            pick up a theme for
                                                            our every furniture.
                                                            We promise you, our
                                                            every furniture have
                                                            something
                                                            fascinating to tell
                                                            you.
                                                        </div>
                                                    </div>

                                                    <div id="woodmart-text-block-id-642288370e9cc"
                                                        class="woodmart-text-block-wrapper color-scheme-light woodmart-title-size-custom woodmart-title-width-100 text-center">
                                                        <div
                                                            class="woodmart-title-container woodmart-text-block font-text woodmart-font-weight-">
                                                            As our all products
                                                            imagined, it’s
                                                            required to sketch.
                                                            We have some handful
                                                            of sketch books of
                                                            our own that
                                                            contains the ideas
                                                            of our furniture.
                                                            Our artists
                                                            hand-create
                                                            prototypes for
                                                            everything from sofa
                                                            set to bed comforter
                                                            to lighting ; from
                                                            office desk to file
                                                            cabinet to pen
                                                            holder.<br />
                                                            Crafted in our
                                                            workstation:<br />
                                                            We have our own
                                                            workstation for
                                                            crafting. We called
                                                            it “A house full of
                                                            innovations”. Our
                                                            imaginations find a
                                                            life in our
                                                            workstation. Hand
                                                            crafting is the most
                                                            beautiful section in
                                                            there. We maintain
                                                            quality as well as
                                                            uniqueness.
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            class="wpb_column vc_column_container vc_col-sm-12 vc_col-md-6 vc_col-has-fill">
                                            <div class="vc_column-inner vc_custom_1515663101396">
                                                <div class="wpb_wrapper">
                                                    <div class="wpb_single_image wpb_content_element vc_align_left">
                                                        <figure class="wpb_wrapper vc_figure">
                                                            <div class="vc_single_image-wrapper vc_box_border_grey">
                                                                <img src="/images/about/sketchdelta.jpg"
                                                                    class="vc_single_image-img attachment-full" alt=""
                                                                    decoding="async" loading="lazy" srcset="
                                                                        /images/about/sketchdelta.jpg          1900w,
                                                                        /images/about/sketchdelta-300x239.jpg   300w,
                                                                        /images/about/sketchdelta-768x612.jpg   768w,
                                                                        /images/about/sketchdelta-1024x815.jpg 1024w,
                                                                        /images/about/sketchdelta-280x223.jpg   280w,
                                                                        /images/about/sketchdelta-600x478.jpg   600w,
                                                                        /images/about/sketchdelta-1200x956.jpg 1200w
                                                                    " sizes="(max-width: 1900px) 100vw, 1900px"
                                                                    width="1900" height="1513" />
                                                            </div>
                                                        </figure>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="vc_row-full-width vc_clearfix"></div>
                                    <div
                                        class="vc_row wpb_row vc_row-fluid vc_custom_1515573176944 vc_row-o-content-middle vc_row-flex">
                                        <div class="wpb_column vc_column_container vc_col-sm-6">
                                            <div class="vc_column-inner vc_custom_1504079673177">
                                                <div class="wpb_wrapper">
                                                    <div
                                                        class="vc_row wpb_row vc_inner vc_row-fluid vc_row-o-content-middle vc_row-flex">
                                                        <div class="wpb_column vc_column_container vc_col-sm-6">
                                                            <div class="vc_column-inner vc_custom_1502454527869">
                                                                <div class="wpb_wrapper">
                                                                    <div
                                                                        class="wpb_single_image wpb_content_element vc_align_center vc_custom_1522756489136">
                                                                        <figure class="wpb_wrapper vc_figure">
                                                                            <div
                                                                                class="vc_single_image-wrapper vc_box_border_grey">
                                                                                <img class="vc_single_image-img"
                                                                                    alt="helpline12" title="helpline12"
                                                                                    src="/images/about/furniturehomedelta-1.jpg"
                                                                                    width="400" height="500" />
                                                                            </div>
                                                                        </figure>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="wpb_column vc_column_container vc_col-sm-6">
                                                            <div class="vc_column-inner vc_custom_1502454533190">
                                                                <div class="wpb_wrapper">
                                                                    <div
                                                                        class="wpb_single_image wpb_content_element vc_align_center vc_custom_1515578921972">
                                                                        <figure class="wpb_wrapper vc_figure">
                                                                            <div
                                                                                class="vc_single_image-wrapper vc_box_border_grey">
                                                                                <img class="vc_single_image-img"
                                                                                    src="/images/about/deltacservice1.jpg"
                                                                                    alt="deltacservice1"
                                                                                    title="deltacservice1" width="400"
                                                                                    height="600" />
                                                                            </div>
                                                                        </figure>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="wpb_column vc_column_container vc_col-sm-6">
                                            <div class="vc_column-inner vc_custom_1504079485859">
                                                <div class="wpb_wrapper">
                                                    <div id="woodmart-text-block-id-642288370fc22"
                                                        class="woodmart-text-block-wrapper color-scheme-dark woodmart-title-size-custom woodmart-title-width-100 text-left vc_custom_1515573070040">
                                                        <div
                                                            class="woodmart-title-container woodmart-text-block font-primary woodmart-font-weight-400">
                                                            <strong>Our
                                                                service:</strong>
                                                        </div>
                                                    </div>

                                                    <div id="woodmart-text-block-id-642288370fc42"
                                                        class="woodmart-text-block-wrapper color-scheme- woodmart-title-size-custom woodmart-title-width-90 text-left vc_custom_1515573144262">
                                                        <div
                                                            class="woodmart-title-container woodmart-text-block font-text woodmart-font-weight-">
                                                            <strong>Create your own
                                                                combination:</strong><br />
                                                            The best part of our
                                                            product is you can
                                                            choose your own
                                                            fabric to create
                                                            your own
                                                            combination. We have
                                                            a hive of quality
                                                            full and design-able
                                                            fabric from where
                                                            you can choose
                                                            fabric for your
                                                            dream furniture. We
                                                            give you the chance
                                                            to create your own
                                                            world in your
                                                            home.<br />
                                                            <strong>Advice from
                                                                professional:</strong><br />
                                                            Sometimes people get
                                                            confused about the
                                                            suitable place for
                                                            their new furniture.
                                                            We want us to help
                                                            you such confusions.
                                                            After buying our
                                                            product, we offer
                                                            “advice service”
                                                            that helps you to
                                                            place your furniture
                                                            in a suitable
                                                            position at your
                                                            home.
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </article>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { useStaticSchema } from '@/libs/utils/seo-helper'
import { ref } from "vue";
useStaticSchema('about')
</script>

<style lang="scss" scoped>
@import "@/assets/css/js_composer.min.css";
@import "@/assets/css/bootstrap.min.css";
@import "@/assets/css/style.min.css";

.vc_custom_1503325156868 {
    margin-bottom: 8vh !important;
}

.vc_custom_1504016749019 {
    margin-bottom: 2vh !important;
}

.vc_custom_1502962403521 {
    margin-bottom: 8vh !important;
    padding-right: 0px !important;
    padding-left: 0px !important;
}

.vc_custom_1504079499615 {
    margin-bottom: 5vh !important;
}

.vc_custom_1504181248563 {
    margin-bottom: 5vh !important;
}

.vc_custom_1504079499615 {
    margin-bottom: 5vh !important;
}

.vc_custom_1515573176944 {
    margin-top: 80px !important;
    margin-bottom: -40px !important;
}

.vc_custom_1503987927476 {
    margin-bottom: 35px !important;
    padding-top: 0px !important;
}

.vc_custom_1504016632988 {
    margin-bottom: 4vh !important;
    padding-top: 0px !important;
}

.vc_custom_1502961612862 {
    padding-top: 0px !important;
}

.vc_custom_1502961619083 {
    padding-top: 0px !important;
}

.vc_custom_1522902979938 {
    margin-bottom: 15px !important;
}

.vc_custom_1515576304324 {
    margin-bottom: 0px !important;
}

.vc_custom_1515565783174 {
    margin-bottom: 15px !important;
}

.vc_custom_1515565894732 {
    margin-bottom: 25px !important;
}

.vc_custom_1502961799206 {
    padding-top: 0px !important;
    padding-right: 0px !important;
    padding-left: 0px !important;
}

.vc_custom_1502961869165 {
    padding-right: 0px !important;
    padding-left: 0px !important;
}

.vc_custom_1502961875388 {
    padding-right: 0px !important;
    padding-left: 0px !important;
}

.vc_custom_1504092645215 {
    padding-top: 0px !important;
    padding-right: 0px !important;
    padding-left: 0px !important;
}

.vc_custom_1504019441256 {
    padding-top: 10% !important;
    padding-right: 0px !important;
    padding-bottom: 10% !important;
    padding-left: 0px !important;
    background-color: #101010 !important;
}

.vc_custom_1515652773973 {
    margin-bottom: 0px !important;
}

.vc_custom_1504019342061 {
    padding-top: 10% !important;
    padding-bottom: 10% !important;
    background-color: #101010 !important;
}

.vc_custom_1515566882223 {
    margin-bottom: 0px !important;
}

.vc_custom_1504079673177 {
    margin-bottom: 25px !important;
    padding-top: 0px !important;
}

.vc_custom_1504079485859 {
    margin-bottom: 35px !important;
    padding-top: 0px !important;
}

.vc_custom_1502454527869 {
    padding-top: 0px !important;
}

.vc_custom_1502454533190 {
    padding-top: 0px !important;
}

.vc_custom_1515577302017 {
    margin-bottom: 15px !important;
}

.vc_custom_1515576800565 {
    margin-bottom: 15px !important;
}

.vc_custom_1515566298837 {
    margin-bottom: 15px !important;
}

.vc_custom_1515566361672 {
    margin-bottom: 25px !important;
}

.vc_custom_1504079490508 {
    margin-bottom: 35px !important;
    padding-top: 0px !important;
}

.vc_custom_1504079666614 {
    margin-bottom: 25px !important;
    padding-top: 0px !important;
}

.vc_custom_1515566392668 {
    margin-bottom: 15px !important;
}

.vc_custom_1515566492129 {
    margin-bottom: 25px !important;
}

.vc_custom_1502454533190 {
    padding-top: 0px !important;
}

.vc_custom_1502454527869 {
    padding-top: 0px !important;
}

.vc_custom_1515578409793 {
    margin-bottom: 15px !important;
}

.vc_custom_1515577585510 {
    margin-bottom: 15px !important;
}

.vc_custom_1504079673177 {
    margin-bottom: 25px !important;
    padding-top: 0px !important;
}

.vc_custom_1504079485859 {
    margin-bottom: 35px !important;
    padding-top: 0px !important;
}

.vc_custom_1502454527869 {
    padding-top: 0px !important;
}

.vc_custom_1502454533190 {
    padding-top: 0px !important;
}

.vc_custom_1515578777936 {
    margin-bottom: 15px !important;
}

.vc_custom_1515578654032 {
    margin-bottom: 15px !important;
}

.vc_custom_1515566567550 {
    margin-bottom: 15px !important;
}

.vc_custom_1515567560455 {
    margin-bottom: 25px !important;
}

.vc_custom_1515663857276 {
    padding-top: 6vh !important;
    padding-right: 10% !important;
    padding-bottom: 6vh !important;
    padding-left: 10% !important;
    background-color: #000000 !important;
    background-position: center !important;
    background-repeat: no-repeat !important;
    background-size: cover !important;
}

.vc_custom_1515663101396 {
    padding-top: 0px !important;
    background-position: 0 0 !important;
    background-repeat: no-repeat !important;
}

.vc_custom_1515568232256 {
    margin-bottom: 15px !important;
}

.vc_custom_1504079673177 {
    margin-bottom: 25px !important;
    padding-top: 0px !important;
}

.vc_custom_1504079485859 {
    margin-bottom: 35px !important;
    padding-top: 0px !important;
}

.vc_custom_1502454527869 {
    padding-top: 0px !important;
}

.vc_custom_1502454533190 {
    padding-top: 0px !important;
}

.vc_custom_1522756489136 {
    margin-bottom: 15px !important;
}

.vc_custom_1515578921972 {
    margin-bottom: 15px !important;
}

.vc_custom_1515573070040 {
    margin-bottom: 15px !important;
}

.vc_custom_1515573144262 {
    margin-bottom: 25px !important;
}

#woodmart-text-block-id-642288370fc42 .woodmart-text-block {
    font-size: 16px;
    line-height: 26px;
}

@media (max-width: 1024px) {
    #woodmart-text-block-id-642288370fc42 .woodmart-text-block {
        font-size: 14px;
        line-height: 24px;
    }
}

@media (max-width: 767px) {
    #woodmart-text-block-id-642288370fc42 .woodmart-text-block {
        font-size: 14px;
        line-height: 24px;
    }
}

#woodmart-text-block-id-642288370e711 .woodmart-text-block {
    font-size: 16px;
    line-height: 26px;
}

@media (max-width: 1024px) {
    #woodmart-text-block-id-642288370e711 .woodmart-text-block {
        font-size: 14px;
        line-height: 24px;
    }
}

@media (max-width: 767px) {
    #woodmart-text-block-id-642288370e711 .woodmart-text-block {
        font-size: 14px;
        line-height: 24px;
    }
}

#woodmart-text-block-id-642288370e994 .woodmart-text-block {
    font-size: 42px;
    line-height: 52px;
}

@media (max-width: 1024px) {
    #woodmart-text-block-id-642288370e994 .woodmart-text-block {
        font-size: 36px;
        line-height: 46px;
    }
}

@media (max-width: 767px) {
    #woodmart-text-block-id-642288370e994 .woodmart-text-block {
        font-size: 24px;
        line-height: 34px;
    }
}

#woodmart-text-block-id-642288370e9b2 .woodmart-text-block {
    font-size: 16px;
    line-height: 26px;
}

@media (max-width: 1024px) {
    #woodmart-text-block-id-642288370e9b2 .woodmart-text-block {
        font-size: 14px;
        line-height: 24px;
    }
}

@media (max-width: 767px) {
    #woodmart-text-block-id-642288370e9b2 .woodmart-text-block {
        font-size: 14px;
        line-height: 24px;
    }
}

#woodmart-text-block-id-642288370e9cc .woodmart-text-block {
    font-size: 16px;
    line-height: 26px;
}

@media (max-width: 1024px) {
    #woodmart-text-block-id-642288370e9cc .woodmart-text-block {
        font-size: 14px;
        line-height: 24px;
    }
}

@media (max-width: 767px) {
    #woodmart-text-block-id-642288370e9cc .woodmart-text-block {
        font-size: 14px;
        line-height: 24px;
    }
}

#woodmart-text-block-id-642288370fc22 .woodmart-text-block {
    font-size: 42px;
    line-height: 52px;
}

@media (max-width: 1024px) {
    #woodmart-text-block-id-642288370fc22 .woodmart-text-block {
        font-size: 36px;
        line-height: 46px;
    }
}

@media (max-width: 767px) {
    #woodmart-text-block-id-642288370fc22 .woodmart-text-block {
        font-size: 24px;
        line-height: 34px;
    }
}

#woodmart-text-block-id-642288370a192 .woodmart-text-block {
    font-size: 42px;
    line-height: 52px;
}

@media (max-width: 1024px) {
    #woodmart-text-block-id-642288370a192 .woodmart-text-block {
        font-size: 36px;
        line-height: 46px;
    }
}

@media (max-width: 767px) {
    #woodmart-text-block-id-642288370a192 .woodmart-text-block {
        font-size: 24px;
        line-height: 34px;
    }
}

#woodmart-text-block-id-642288370a1b9 .woodmart-text-block {
    font-size: 16px;
    line-height: 26px;
}

@media (max-width: 1024px) {
    #woodmart-text-block-id-642288370a1b9 .woodmart-text-block {
        font-size: 14px;
        line-height: 24px;
    }
}

@media (max-width: 767px) {
    #woodmart-text-block-id-642288370a1b9 .woodmart-text-block {
        font-size: 14px;
        line-height: 24px;
    }
}

#woodmart-text-block-id-642288370cc40 .woodmart-text-block {
    font-size: 42px;
    line-height: 52px;
}

@media (max-width: 1024px) {
    #woodmart-text-block-id-642288370cc40 .woodmart-text-block {
        font-size: 36px;
        line-height: 46px;
    }
}

@media (max-width: 767px) {
    #woodmart-text-block-id-642288370cc40 .woodmart-text-block {
        font-size: 24px;
        line-height: 34px;
    }
}

#woodmart-text-block-id-642288370cc62 .woodmart-text-block {
    font-size: 16px;
    line-height: 26px;
}

@media (max-width: 1024px) {
    #woodmart-text-block-id-642288370cc62 .woodmart-text-block {
        font-size: 14px;
        line-height: 24px;
    }
}

@media (max-width: 767px) {
    #woodmart-text-block-id-642288370cc62 .woodmart-text-block {
        font-size: 14px;
        line-height: 24px;
    }
}

#woodmart-text-block-id-642288370ce86 .woodmart-text-block {
    font-size: 42px;
    line-height: 52px;
}

@media (max-width: 1024px) {
    #woodmart-text-block-id-642288370ce86 .woodmart-text-block {
        font-size: 36px;
        line-height: 46px;
    }
}

@media (max-width: 767px) {
    #woodmart-text-block-id-642288370ce86 .woodmart-text-block {
        font-size: 24px;
        line-height: 34px;
    }
}

#woodmart-text-block-id-642288370cea8 .woodmart-text-block {
    font-size: 16px;
    line-height: 26px;
}

@media (max-width: 1024px) {
    #woodmart-text-block-id-642288370cea8 .woodmart-text-block {
        font-size: 14px;
        line-height: 24px;
    }
}

@media (max-width: 767px) {
    #woodmart-text-block-id-642288370cea8 .woodmart-text-block {
        font-size: 14px;
        line-height: 24px;
    }
}

#woodmart-text-block-id-642288370e6f1 .woodmart-text-block {
    font-size: 42px;
    line-height: 52px;
}

@media (max-width: 1024px) {
    #woodmart-text-block-id-642288370e6f1 .woodmart-text-block {
        font-size: 36px;
        line-height: 46px;
    }
}

@media (max-width: 767px) {
    #woodmart-text-block-id-642288370e6f1 .woodmart-text-block {
        font-size: 24px;
        line-height: 34px;
    }
}

.about-us-banner {
    //   border: 1px solid transparent;
    //   border-radius: 20px;
    background-color: #f5f5f5;
    //   padding: 96px;
    // padding: 96px 16%;
    // padding: 96px 10%;
    padding: 0 10%;
    height: 50vh;
    text-align: center;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
}

.bg-section {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-end;
}

.bg-text {
    font-size: 6.25rem !important;
    font-weight: 700;
    color: #fff;
    // line-height: 70%;
    line-height: 114%;
    padding: 20px 20px 0;
    // background-color: rgba(222, 222, 222, 0.5);
    border-radius: 10px 10px 0px 0;
}

@media screen and (max-width: 690px) {
    .bg-text {
        font-size: 2.75rem !important;
    }
    .bg-section {
        align-items: center !important;
    }
}
// @media screen and (max-width: 400px) {
//     .bg-section {
//         align-items: center !important;
//     }
// }
</style>
